module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.dialogTitle,
      "width": "640px",
      "modal-append-to-body": false,
      "custom-class": "ad-add-crowd-dialog",
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.handleDialogClose
    },
    model: {
      value: (_vm.visibleProxy),
      callback: function($$v) {
        _vm.visibleProxy = $$v
      },
      expression: "visibleProxy"
    }
  }, [_c('div', {
    staticClass: "crowd-dialog-body"
  }, [_c('el-form', {
    ref: "formRef",
    staticClass: "crowd-dialog-form",
    attrs: {
      "model": _vm.form,
      "label-position": "left",
      "label-width": "168px"
    }
  }, [_c('el-form-item', [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" 人群名称\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "crowd-field-block"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "最多20个字",
      "maxlength": 20,
      "clearable": ""
    },
    on: {
      "blur": _vm.validateName
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  }), _vm._v(" "), (_vm.isDuplicateName) ? _c('div', {
    staticClass: "crowd-field-error"
  }, [_vm._v("人群名称不允许重复")]) : _vm._e()], 1)], 2), _vm._v(" "), _c('el-form-item', [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" 人群说明\n        ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "最多50个字",
      "maxlength": 50,
      "clearable": ""
    },
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.$set(_vm.form, "description", $$v)
      },
      expression: "form.description"
    }
  })], 2), _vm._v(" "), _c('el-form-item', [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" 是否学校任务跑用户\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "crowd-field-block"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.isSchoolRunUser),
      callback: function($$v) {
        _vm.$set(_vm.form, "isSchoolRunUser", $$v)
      },
      expression: "form.isSchoolRunUser"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "yes"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "no"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('div', {
    staticClass: "crowd-hint crowd-hint--red"
  }, [_vm._v("\n            * 学校任务跑用户，在「运营后台-校区管理」中配置\n          ")])], 1)], 2), _vm._v(" "), _c('el-form-item', [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" 学期是否开始\n        ")]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.form.semesterStarted),
      callback: function($$v) {
        _vm.$set(_vm.form, "semesterStarted", $$v)
      },
      expression: "form.semesterStarted"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "any"
    }
  }, [_vm._v("不限")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "yes"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "no"
    }
  }, [_vm._v("否")])], 1)], 2), _vm._v(" "), _c('el-form-item', [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" 是否有校园跑学期目标\n        ")]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.form.hasSemesterGoal),
      callback: function($$v) {
        _vm.$set(_vm.form, "hasSemesterGoal", $$v)
      },
      expression: "form.hasSemesterGoal"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "any"
    }
  }, [_vm._v("不限")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "yes"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "no"
    }
  }, [_vm._v("否")])], 1)], 2), _vm._v(" "), (_vm.form.hasSemesterGoal === 'yes') ? _c('el-form-item', [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" 目标进度要求\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "semester-progress-row"
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#409eff",
      "inactive-color": "#dcdfe6"
    },
    model: {
      value: (_vm.form.semesterProgressEnabled),
      callback: function($$v) {
        _vm.$set(_vm.form, "semesterProgressEnabled", $$v)
      },
      expression: "form.semesterProgressEnabled"
    }
  }), _vm._v(" "), (_vm.form.semesterProgressEnabled) ? [_c('span', {
    staticClass: "semester-progress-text"
  }, [_vm._v("完成进度 ≥")]), _vm._v(" "), _c('el-input', {
    staticClass: "semester-progress-input",
    attrs: {
      "placeholder": "0-100",
      "maxlength": "3"
    },
    on: {
      "input": _vm.onSemesterProgressPercentInput
    },
    model: {
      value: (_vm.form.semesterProgressPercent),
      callback: function($$v) {
        _vm.$set(_vm.form, "semesterProgressPercent", $$v)
      },
      expression: "form.semesterProgressPercent"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "semester-progress-unit"
  }, [_vm._v("%")])] : _vm._e()], 2)], 2) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" 跑步时段\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "running-time-box"
  }, [_c('div', {
    staticClass: "running-days"
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.form.weekDays),
      callback: function($$v) {
        _vm.$set(_vm.form, "weekDays", $$v)
      },
      expression: "form.weekDays"
    }
  }, _vm._l((_vm.weekDayOptions), function(d) {
    return _c('el-checkbox', {
      key: d.value,
      attrs: {
        "label": d.value
      }
    }, [_vm._v("\n                " + _vm._s(d.label) + "\n              ")])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "running-time-type-row"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.runningTimeType),
      callback: function($$v) {
        _vm.$set(_vm.form, "runningTimeType", $$v)
      },
      expression: "form.runningTimeType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "allDay"
    }
  }, [_vm._v("全天")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "range"
    }
  }, [_vm._v("指定时段")])], 1), _vm._v(" "), (_vm.form.runningTimeType === 'range') ? _c('div', {
    staticClass: "running-time-range"
  }, [_c('el-select', {
    staticClass: "time-part-select",
    attrs: {
      "placeholder": "时"
    },
    model: {
      value: (_vm.form.timeStartHour),
      callback: function($$v) {
        _vm.$set(_vm.form, "timeStartHour", $$v)
      },
      expression: "form.timeStartHour"
    }
  }, _vm._l((_vm.hourOptions), function(item) {
    return _c('el-option', {
      key: 'start-hour-' + item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "time-label"
  }, [_vm._v("时")]), _vm._v(" "), _c('el-select', {
    staticClass: "time-part-select",
    attrs: {
      "placeholder": "分"
    },
    model: {
      value: (_vm.form.timeStartMinute),
      callback: function($$v) {
        _vm.$set(_vm.form, "timeStartMinute", $$v)
      },
      expression: "form.timeStartMinute"
    }
  }, _vm._l((_vm.minuteOptions), function(item) {
    return _c('el-option', {
      key: 'start-minute-' + item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "time-label"
  }, [_vm._v("分")]), _vm._v(" "), _c('span', {
    staticClass: "time-sep"
  }, [_vm._v("-")]), _vm._v(" "), _c('el-select', {
    staticClass: "time-part-select",
    attrs: {
      "placeholder": "时"
    },
    model: {
      value: (_vm.form.timeEndHour),
      callback: function($$v) {
        _vm.$set(_vm.form, "timeEndHour", $$v)
      },
      expression: "form.timeEndHour"
    }
  }, _vm._l((_vm.hourOptions), function(item) {
    return _c('el-option', {
      key: 'end-hour-' + item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "time-label"
  }, [_vm._v("时")]), _vm._v(" "), _c('el-select', {
    staticClass: "time-part-select",
    attrs: {
      "placeholder": "分"
    },
    model: {
      value: (_vm.form.timeEndMinute),
      callback: function($$v) {
        _vm.$set(_vm.form, "timeEndMinute", $$v)
      },
      expression: "form.timeEndMinute"
    }
  }, _vm._l((_vm.minuteOptions), function(item) {
    return _c('el-option', {
      key: 'end-minute-' + item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "time-label"
  }, [_vm._v("分")])], 1) : _vm._e()], 1)])], 2)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.visibleProxy = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v("保存")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cf3af158!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/AdvertisingSpace/AdManagement/Components/AdAddCrowdDialog.vue
// module id = 1130
// module chunks = 0